/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageSeriesList/view.blocks to change it.
import * as fromData from 'Simple/Data'
import ImageSerie from './ImageSerie/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ImageSeriesList({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/ImageSeries/Body/Content/ImageSeriesList"
  
}) {
let imageSeriesValueData = fromData.useDataValue({ viewPath,
context: 'image_series',
})
  return (<React.Fragment
>
<div
  data-testid="ImageSeriesList.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(imageSeriesValueData) && imageSeriesValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="image_serie"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/ImageSerie(${item?.id ?? item?._id ?? index})`}
      >
<ImageSerie
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/ImageSerie(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }